import {
  NASELJA,
  NAZIVI_STANJA,
  NAZIVI_VEZE,
  razdvojiKoordinate,
} from '../lib/konstante';
import { noviKontakt } from '../lib/unosKucanstva';
import Ikona from './Ikona';

export default function PoljaKucanstva({
  podaci,
  kontakti,
  naPodatke,
  naKontakte,
  zauzeto = false,
  mozePotvrditi = false,
}) {
  const polje = (kljuc, vrijednost) =>
    naPodatke({ ...podaci, [kljuc]: vrijednost });
  const kontakt = (indeks, kljuc, vrijednost) =>
    naKontakte(
      kontakti.map((k, i) =>
        i === indeks
          ? { ...k, [kljuc]: vrijednost }
          : kljuc === 'glavni' && vrijednost
            ? { ...k, glavni: false }
            : k,
      ),
    );
  const koordinate = (kljuc, vrijednost) => {
    const par = razdvojiKoordinate(vrijednost);
    naPodatke(
      par
        ? {
            ...podaci,
            lat: String(par[0]),
            lng: String(par[1]),
            potvrdi_lokaciju: false,
          }
        : { ...podaci, [kljuc]: vrijednost, potvrdi_lokaciju: false },
    );
  };
  return (
    <fieldset className="polja-kucanstva" disabled={zauzeto}>
      <section className="ploca odjeljak-obrasca">
        <div className="naslov-obrasca">
          <span>01</span>
          <div>
            <h2>Adresa i nositelj</h2>
            <p>Jedna adresa predstavlja jedno kućanstvo.</p>
          </div>
        </div>
        <div className="mreza-polja">
          <label>
            Naselje <b>*</b>
            <select
              value={podaci.naselje}
              onChange={(e) => polje('naselje', e.target.value)}
              required
            >
              <option value="">Odaberi naselje</option>
              {NASELJA.map((n) => (
                <option key={n.naziv}>{n.naziv}</option>
              ))}
            </select>
          </label>
          <label>
            Kućni broj
            <input
              value={podaci.kucni_broj}
              onChange={(e) => polje('kucni_broj', e.target.value)}
              maxLength={40}
              placeholder="Npr. 13a, 159/1 ili bb"
              autoComplete="off"
            />
          </label>
          {(!podaci.kucni_broj ||
            podaci.kucni_broj.toLowerCase().trim() === 'bb' ||
            podaci.opis_lokacije) && (
            <label className="puna-sirina">
              Opis lokacije{' '}
              {!podaci.kucni_broj ||
              podaci.kucni_broj.toLowerCase().trim() === 'bb' ? (
                <b>*</b>
              ) : null}
              <input
                value={podaci.opis_lokacije}
                onChange={(e) => polje('opis_lokacije', e.target.value)}
                maxLength={1000}
                placeholder="Kako pronaći kuću ako nema kućnog broja?"
              />
            </label>
          )}
          <label>
            Ime nositelja <b>*</b>
            <input
              value={podaci.nositelj_ime}
              onChange={(e) => polje('nositelj_ime', e.target.value)}
              required
              maxLength={120}
              autoComplete="off"
            />
          </label>
          <label>
            Prezime nositelja <b>*</b>
            <input
              value={podaci.nositelj_prezime}
              onChange={(e) => polje('nositelj_prezime', e.target.value)}
              required
              maxLength={120}
              autoComplete="off"
            />
          </label>
          <label>
            Broj priključaka <b>*</b>
            <input
              type="number"
              inputMode="numeric"
              min="0"
              max="20"
              step="1"
              required
              value={podaci.broj_prikljucaka}
              onChange={(e) => polje('broj_prikljucaka', e.target.value)}
            />
          </label>
          <label>
            Godina priključenja
            <input
              type="number"
              inputMode="numeric"
              min="1970"
              max="2100"
              step="1"
              value={podaci.godina_prikljucenja}
              onChange={(e) => polje('godina_prikljucenja', e.target.value)}
              placeholder="Neobavezno"
            />
            <small>1983. znači od početka rada vodovoda.</small>
          </label>
          <label className="puna-sirina">
            Stanje kućanstva
            <select
              value={podaci.stanje}
              onChange={(e) => polje('stanje', e.target.value)}
            >
              {Object.entries(NAZIVI_STANJA).map(([v, n]) => (
                <option key={v} value={v}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        </div>
      </section>
      <section className="ploca odjeljak-obrasca">
        <div className="naslov-obrasca">
          <span>02</span>
          <div>
            <h2>Kontakti</h2>
            <p>Neobavezno. Odaberi glavni kontakt za obavijesti o vodovodu.</p>
          </div>
        </div>
        {kontakti.map((k, i) => (
          <div className="kontakt-obrazac" key={k.id ?? i}>
            <div className="kontakt-alati">
              <strong>Kontakt {i + 1}</strong>
              <button
                type="button"
                className="tekst-gumb"
                onClick={() => naKontakte(kontakti.filter((_, j) => j !== i))}
              >
                Ukloni kontakt
              </button>
            </div>
            <div className="mreza-polja">
              <label>
                Ime kontakta <b>*</b>
                <input
                  value={k.ime}
                  onChange={(e) => kontakt(i, 'ime', e.target.value)}
                  maxLength={120}
                  required
                />
              </label>
              <label>
                Prezime kontakta <b>*</b>
                <input
                  value={k.prezime}
                  onChange={(e) => kontakt(i, 'prezime', e.target.value)}
                  maxLength={120}
                  required
                />
              </label>
              <label>
                Veza s nositeljem
                <select
                  value={k.veza}
                  onChange={(e) => kontakt(i, 'veza', e.target.value)}
                >
                  {Object.entries(NAZIVI_VEZE).map(([v, n]) => (
                    <option value={v} key={v}>
                      {n}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Telefon
                <input
                  type="tel"
                  value={k.telefon ?? ''}
                  onChange={(e) => kontakt(i, 'telefon', e.target.value)}
                  placeholder="Npr. 098 123 4567"
                  maxLength={60}
                />
              </label>
              <label className="puna-sirina">
                E-mail
                <input
                  type="email"
                  value={k.email ?? ''}
                  onChange={(e) => kontakt(i, 'email', e.target.value)}
                  maxLength={254}
                />
              </label>
              <label className="redak-kvacice">
                <input
                  type="checkbox"
                  checked={k.glavni}
                  onChange={(e) => kontakt(i, 'glavni', e.target.checked)}
                />
                Glavni kontakt
              </label>
              <label className="redak-kvacice">
                <input
                  type="checkbox"
                  checked={k.telefon_nositelja}
                  onChange={(e) =>
                    kontakt(i, 'telefon_nositelja', e.target.checked)
                  }
                />
                Telefon pripada nositelju
              </label>
            </div>
          </div>
        ))}
        <div className="dodavanje-kontakta">
          <button
            type="button"
            className="gumb sek"
            disabled={kontakti.length >= 20}
            onClick={() =>
              naKontakte([
                ...kontakti,
                { ...noviKontakt(), glavni: kontakti.length === 0 },
              ])
            }
          >
            + Dodaj kontakt
          </button>
          <button
            type="button"
            className="tekst-gumb"
            disabled={
              !podaci.nositelj_ime ||
              !podaci.nositelj_prezime ||
              kontakti.length >= 20
            }
            onClick={() =>
              naKontakte([
                ...kontakti,
                {
                  ...noviKontakt(),
                  ime: podaci.nositelj_ime,
                  prezime: podaci.nositelj_prezime,
                  glavni: kontakti.length === 0,
                },
              ])
            }
          >
            Nositelj je kontakt <Ikona naziv="strelica" velicina={15} />
          </button>
        </div>
      </section>
      <section className="ploca odjeljak-obrasca">
        <div className="naslov-obrasca">
          <span>03</span>
          <div>
            <h2>Lokacija i napomena</h2>
            <p>Lokaciju možeš dopuniti i kasnije. Pinovi se ne povlače.</p>
          </div>
        </div>
        <div className="mreza-polja">
          <label>
            Geografska širina
            <input
              inputMode="decimal"
              value={podaci.lat ?? ''}
              onChange={(e) => koordinate('lat', e.target.value)}
              placeholder="45.963791"
              autoComplete="off"
            />
          </label>
          <label>
            Geografska dužina
            <input
              inputMode="decimal"
              value={podaci.lng ?? ''}
              onChange={(e) => koordinate('lng', e.target.value)}
              placeholder="16.034846"
              autoComplete="off"
            />
          </label>
          {mozePotvrditi && podaci.lat && podaci.lng && (
            <label className="redak-kvacice puna-sirina">
              <input
                type="checkbox"
                checked={!!podaci.potvrdi_lokaciju}
                onChange={(e) => polje('potvrdi_lokaciju', e.target.checked)}
              />
              Provjerio/la sam ovu lokaciju na ortofotu ili na terenu.
            </label>
          )}
          <p className="pomoc-polja puna-sirina">
            Bez potvrde uprave lokacija ostaje označena za provjeru. Obje
            koordinate možeš zalijepiti u jedno polje.
          </p>
          <label className="puna-sirina">
            Napomena
            <textarea
              rows="3"
              value={podaci.napomena}
              onChange={(e) => polje('napomena', e.target.value)}
              maxLength={2000}
              placeholder="Samo informacije važne za ovo kućanstvo."
            />
          </label>
        </div>
      </section>
    </fieldset>
  );
}
